import { render, staticRenderFns } from "./Direcciones.vue?vue&type=template&id=f066db96&scoped=true"
import script from "./Direcciones.vue?vue&type=script&lang=js"
export * from "./Direcciones.vue?vue&type=script&lang=js"
import style0 from "./Direcciones.vue?vue&type=style&index=0&id=f066db96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f066db96",
  null
  
)

export default component.exports